import { useEffect, useState } from "react";
import { useApi } from "utils";
import { DataBoqType } from "../types/BoqTypes";

export type SuccessFetch = {
status: string;
responseStatus: number;
message: string;
payload:{
    boq_data:DataBoqType[]
};
};

export function useBoqDetail(project_id?: string) {
    const api = useApi();
    const [detailBoq, setData] = useState<DataBoqType[]>([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState<string | null>(null);

    const fetchData = async () => {
        setLoading(true);
        setError(null);
        try {
            const res = await api.get(`projectget_boq_by_project_id`, {
                params: { project_id: project_id },
            });
            const response: SuccessFetch = res.data;
            setData(response.payload?.boq_data);       
            setLoading(false);     
        } catch (err: any) {
            setError(err?.response?.data?.message || "Failed to fetch data");
            setData([]);
            setLoading(false);
        } finally {
            setLoading(false);
        }
    };

    const refetchBoq = () => fetchData()

    useEffect(() => {
        // jangan fetch kalau tidak ada id (mode create)
        if (!project_id) return;
        fetchData();
         // eslint-disable-next-line
    }, [project_id]);

    return { 
        detailBoq, 
        loading, 
        error, 
        refetchBoq,
        dropdownBoq: detailBoq?.map((item) => ({
            ...item,
            label: item.boq_name,
            value: String(item.project_boq_id ?? 0)
          })),
    };
}
